import { QueryAggregator } from "@/api/utils/QueryAggregator"
import { AccountService } from "@/services/AccountService"
import { PsrService } from "@/services/PsrService"
import { IPsrCustomerSettings } from "@/models/psr/psr.types"

export const getCustomerPsrSettings = (accountNumber: string) => {
  const queries = new QueryAggregator()
  let customerPsrSettings: IPsrCustomerSettings = {} as IPsrCustomerSettings

  const customerIdQuery =
    AccountService.getCustomerIdByAccountNumber(accountNumber)

  queries.add(customerIdQuery)

  if (customerIdQuery.data) {
    const customerPsrQuery = PsrService.getCustomerSettings(
      customerIdQuery.data,
    )
    queries.add(customerPsrQuery)
    customerPsrSettings = customerPsrQuery.data
  }

  return queries.setData(customerPsrSettings).getAggregate()
}
